const getStepper = (state) => {
    return state.stepper_value
}


const getLatLng = (state) => {
    return state.form_proyecto.lat_lng.value
}


const getPresupuestos = (state) => {
    return state.presupuestos
}

const getDesembolsos = (state) => {
    return state.desembolsos
}

const getObservacionesGenerales = (state) => {
    return state.observaciones_carpeta.filter(item => !item.carpeta_tecnica && item.fecha_aceptacion===null)
}

const getObservacionesForCategory = (state) => id_category => {
    return state.observaciones_carpeta.filter(item => item.carpeta_tecnica && item.carpeta_tecnica.id_contenido_carpeta_tecnica === id_category)
}

const canAceptCategoryCarpetaTecnica = (state) => id_category => {
    return !state.observaciones_carpeta.find(item => item.carpeta_tecnica && item.carpeta_tecnica.id_contenido_carpeta_tecnica === id_category && !item.fecha_aceptacion)
}

const aceptadaCarpetaTecnica = (state) => id_category => {
    let aux = state.observaciones_carpeta.find(item => {
        return item.carpeta_tecnica && item.carpeta_tecnica.id_contenido_carpeta_tecnica === id_category && !item.carpeta_tecnica.fecha_cumplimiento !== null
    })

    if (!aux) return true
    return !!aux
}

const mostrarCreateObservacion = (state) => id_category => {
    return state.observaciones_carpeta.find(item => {
        return item.carpeta_tecnica && item.carpeta_tecnica.id_contenido_carpeta_tecnica === id_category && !item.carpeta_tecnica.fecha_cumplimiento !== null
    })
}

const canFinalyRecepcion = (state) => {
    let generales = state.observaciones_carpeta.filter(item => item.carpeta_tecnica === null)
    return state.categorias_aceptadas.length === state.carpeta_items.length && !generales.find(general => general.fecha_aceptacion == null)
}

const carpetaAceptada = (state) => id_category => {
    return !!state.categorias_aceptadas.find(item => item.id === id_category)
}

const allObservacionesAceptadas=(state)=>{
    return !state.observaciones_carpeta.find(item=>item.fecha_aceptacion===null)
}

export {
    getStepper,
    getLatLng,
    getPresupuestos,
    getDesembolsos,
    getObservacionesForCategory,
    canAceptCategoryCarpetaTecnica,
    aceptadaCarpetaTecnica,
    canFinalyRecepcion,
    mostrarCreateObservacion,
    carpetaAceptada,
    getObservacionesGenerales,
    allObservacionesAceptadas
}
